import { ContactEditorial } from '@/components/ContactEditorial';
import { LabradorComponent } from '@/types/component';

export const LabradorContactEditorial: LabradorComponent = ({ data, type, meta, descendants, ...props }) => {
  const content = {
    headline: 'Lämna ditt tips!',
    caption:
      'Dela din historia eller tips med oss.. Om du vill vara anonym kan du lämna namn, telefonnummer och e-postfälten tomma',
    label: {
      message: 'Skriv dit tips',
      name: 'Namn (frivilligt)',
      phone: 'Telefonnummer ( (frivilligt)',
      email: 'E-post (frivilligt)',
      legal:
        'Jag samtycker för behandling av ovan personuppgifter. Jag är medveten om att mina personuppgifter sparas x antal månader och att det sker manuell radering därefter.',
    },
    submitButton: 'Skicka tips',
    dialog: {
      headline: 'Tack!',
      content: 'Vi läser ditt meddelande så snart vi kan.',
      dialogIcon: 'sent',
      primaryButton: 'Ok',
    },
  };

  return <ContactEditorial {...content} {...props} />;
};
